import { ReactNode } from "react";
import styled from "styled-components";

// This is using the same values as the TopNavigationBar Source Web component.
const MaxWidthContainerStyles = styled.div<{ children: ReactNode }>`
  width: 100%;
  max-width: 1232px;
  margin: 0 auto;
`;

export default MaxWidthContainerStyles;
